export const CREATE_USER_ACTION = '[User Action] Create User';
export const CONFIRMED_CREATE_USER_ACTION = '[User Action] Confirmed Create User';
export const CREATE_USER_ERROR_ACTION = '[User Action] Create User Error';
export const GET_USERS = '[User Action] Get Users';
export const CONFIRMED_GET_USERS = '[User Action] Confirmed Get Users';
export const LOADING_USERS = '[User Action] Loading for Users';
export const EDIT_USER_ACTION = '[User Action] Edit User';
export const CONFIRMED_EDIT_USER_ACTION = '[User Action] Confirmed Edit User';
export const DELETE_USER_ACTION = '[User Action] Delete User';
export const CONFIRMED_DELETE_USER_ACTION = '[User Action] Confirmed Delete User';
export const USER_ERROR_ACTION = '[User Action] Error';
export const CLEAR_USER_ERROR = '[User Action] Clear Error';
export const CONFIRMED_UPDATE_STATUS_ACTION = '[User Action] Update status';
